import { ChangeEvent, MouseEvent, useEffect, useState, useRef } from 'react'
import styles from './dropdown.module.scss'
import cx from 'classnames'
import { SearchIcon, ArrowDIcon } from 'assets/svgs'

const LISTITEM = ['안녕하세요', '✨', '반가워여!', '✨✨', '안녕안녕하세요', '반가워요', 'A', 'AA', 'ABC', 'AbCd']

const Dropdown = () => {
  const [searchTxt, setsearchTxt] = useState('')
  const [title, setTitle] = useState('이제 곧 여름이다')
  const [openDropdown, setOpenDropdown] = useState(false)
  const isOutsideClick = useRef<HTMLDivElement>(null)

  const handleOpenDropdown = () => {
    setOpenDropdown((prev) => !prev)
  }

  const handelsearchTxt = (e: ChangeEvent<HTMLInputElement>) => {
    setsearchTxt(e.currentTarget.value)
  }

  const hadleTitle = (e: MouseEvent<HTMLButtonElement>) => {
    setOpenDropdown(false)
    setTitle(e.currentTarget.value)
  }

  useEffect(() => {
    const handleOutsideClick = (e: any) => {
      if (openDropdown && !isOutsideClick.current?.contains(e.target)) setOpenDropdown(false)
    }
    document.addEventListener('mousedown', handleOutsideClick)
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [openDropdown])
  return (
    <div className={styles.dropdownWrap}>
      <div className={styles.titleWrap}>
        <h1>{title}</h1>
        <button type='button' onClick={handleOpenDropdown}>
          <ArrowDIcon />
        </button>
      </div>

      <div className={cx(styles.listWrap, { [styles.closeDropdown]: !openDropdown })} ref={isOutsideClick}>
        <div className={styles.inputWrap}>
          <SearchIcon />
          <input type='text' placeholder='검색어 입력' className={styles.searchInput} onChange={handelsearchTxt} />
        </div>
        <ul>
          {LISTITEM.filter((beforeListItem) => {
            if (!searchTxt) return beforeListItem
            if (beforeListItem.toLowerCase().includes(searchTxt.toLowerCase())) return beforeListItem
            return ''
          }).map((afterListItem) => {
            return (
              <li key={afterListItem}>
                <button type='button' onClick={hadleTitle} value={afterListItem}>
                  {afterListItem}
                </button>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default Dropdown
